// import React, { useState, useRef, useEffect } from 'react';
// import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
// import { Dropdown } from 'react-bootstrap';

// Chart.register(ArcElement, Tooltip, Legend);

// const companyOptions = [
//     { value: 'company-a', label: 'Company A' },
//     { value: 'company-b', label: 'Company B' },
//     { value: 'company-c', label: 'Company C' },
// ];

// const yearOptions = [
//     { value: '2022', label: '2022' },
//     { value: '2023', label: '2023' },
//     { value: '2024', label: '2024' },
// ];

// const CustomerStatusChart = () => {
//     const [selectedCompany, setSelectedCompany] = useState(companyOptions[0]);
//     const [selectedYear, setSelectedYear] = useState(yearOptions[0]);
//     const chartRef = useRef(null);
//     const chartInstance = useRef(null);

//     const handleCompanySelect = (company) => {
//         setSelectedCompany(company);
//     };

//     const handleYearSelect = (year) => {
//         setSelectedYear(year);
//     };

//     useEffect(() => {
//         const ctx = chartRef.current.getContext('2d');

//         if (chartInstance.current) {
//             chartInstance.current.destroy();
//         }

//         chartInstance.current = new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: ['Active', 'In-Active', 'New'],
//                 datasets: [{
//                     data: [350, 50, 100],
//                     backgroundColor: ['#00C49F', '#FF4848', '#FFBB28'],
//                     borderWidth: 0,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '70%',
//                 plugins: {
//                     legend: {
//                         display: false
//                     },
//                     tooltip: {
//                         callbacks: {
//                             label: function (tooltipItem) {
//                                 return `${tooltipItem.label}: ${tooltipItem.raw}`;
//                             },
//                         },
//                     },
//                 },
//             },
//         });

//         return () => {
//             if (chartInstance.current) {
//                 chartInstance.current.destroy();
//             }
//         };
//     }, [selectedCompany, selectedYear]);

//     return (
//         <div className='barchart-container relation-type-chart-container'>
//             <div>
//                 <h6>Customer Status</h6>
//                 <div className='relation-type-chart-btns'>
//                     <Dropdown>
//                         <Dropdown.Toggle id="dropdown-company">
//                             {selectedCompany.label}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             {companyOptions.map(option => (
//                                 <Dropdown.Item
//                                     key={option.value}
//                                     onClick={() => handleCompanySelect(option)}
//                                     active={selectedCompany.value === option.value}
//                                 >
//                                     {option.label}
//                                 </Dropdown.Item>
//                             ))}
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown>
//                         <Dropdown.Toggle id="dropdown-year">
//                             {selectedYear.label}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             {yearOptions.map(option => (
//                                 <Dropdown.Item
//                                     key={option.value}
//                                     onClick={() => handleYearSelect(option)}
//                                     active={selectedYear.value === option.value}
//                                 >
//                                     {option.label}
//                                 </Dropdown.Item>
//                             ))}
//                         </Dropdown.Menu>
//                     </Dropdown>
//                 </div>
//             </div>
//             <div className='customer-status-chart'>
//                 <div style={{ width: '50%', height: '150px' }}>
//                     <canvas ref={chartRef} />
//                 </div>
//                 <div style={{ fontSize: '14px', textAlign: 'right' }}>
//                     <p>Total: <strong>500</strong></p>
//                     <p style={{ color: '#00C49F' }}>Active: <strong>350</strong></p>
//                     <p style={{ color: '#FF4848' }}>In-Active: <strong>50</strong></p>
//                     <p style={{ color: '#FFBB28' }}>New: <strong>100</strong></p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CustomerStatusChart;




import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { Carousel, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadCompanyDropdownData, loadCustomerDashboardStatusChartData, loadLicenceDashboardLicenseStatusChartData } from '../../redux/action';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import * as ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import { saveAs } from "file-saver";

Chart.register(ArcElement, Tooltip, Legend);

const companyOptions = [
    { value: 'company-a', label: 'Company A' },
    { value: 'company-b', label: 'Company B' },
    { value: 'company-c', label: 'Company C' },
];

const yearOptions = [
    { value: '2022', label: '2022' },
    { value: '2023', label: '2023' },
    { value: '2024', label: '2024' },
];

const CustomerStatusChart = React.forwardRef(({
    moduleName = 'Customer Status',
    // labels = [],
    // data = [],
    // colors = [] 
}, ref) => {
    let dispatch = useDispatch();
    const location = useLocation();

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null;
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null;
    const currentYear = new Date().getFullYear();

    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { getCustomerDashboardStatusChartData } = useSelector((state) => state.data);
    const { getLicenseDashboardLicenceStatusData } = useSelector((state) => state.data);

    const [selectedCompany, setSelectedCompany] = useState({ value: storedCompanyId, label: storedCompanyName });
    const [selectedYear, setSelectedYear] = useState({ value: currentYear, label: currentYear });
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
        // Add logic to update chart data based on selected company
    };

    const handleYearSelect = (year) => {
        setSelectedYear(year);
        // Add logic to update chart data based on selected year
    };

    // Function to generate year range from startYear to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear(); // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const yearOptions = generateYearRange(2022); // Generate years from 2022 to the current year

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
    }, [dispatch]);

    // useEffect(() => {
    //     dispatch(loadCustomerDashboardStatusChartData(selectedCompany.value, selectedYear.value));
    // }, [selectedCompany, selectedYear, dispatch]);

    // useEffect(() => {
    //     dispatch(loadLicenceDashboardLicenseStatusChartData(selectedCompany.value, selectedYear.value));
    // }, [selectedCompany, selectedYear, dispatch]);

    useEffect(() => {
        if (location.pathname === '/dashboard' || location.pathname === '/') {
            if (selectedCompany && selectedYear) {
                dispatch(loadCustomerDashboardStatusChartData(selectedCompany.value, selectedYear.value));
            }
        } else if (location.pathname === '/licenceDashboard') {
            if (selectedCompany && selectedYear) {
                dispatch(loadLicenceDashboardLicenseStatusChartData(selectedCompany.value, selectedYear.value));
            }
        }
    }, [selectedCompany, selectedYear, dispatch, location.pathname]);

    useEffect(() => {
        const ctx = chartRef.current.getContext('2d');

        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        let labels, data, colors;

        if (location.pathname === '/licenceDashboard') {
            labels = ['Active', 'Inactive'];
            data = [
                getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0,
                getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0
            ];
            colors = ['#3AC977', '#FF5E5E'];
        } else {
            labels = ['Active', 'Inactive'];
            data = [
                getCustomerDashboardStatusChartData?.ActiveCustomers || 0,
                getCustomerDashboardStatusChartData?.InActiveCustomers || 0
            ];
            colors = ['#3AC977', '#FF5E5E'];
        }

        chartInstance.current = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: colors,
                    borderWidth: 0,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '70%',
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                return `${tooltipItem.label}: ${tooltipItem.raw}`;
                            },
                        },
                    },
                },
            },
        });

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [getCustomerDashboardStatusChartData, getLicenseDashboardLicenceStatusData, selectedCompany, selectedYear, location.pathname]);

    const total = location.pathname === '/licenceDashboard'
        ? getLicenseDashboardLicenceStatusData?.TotalLicenses || 0
        : getCustomerDashboardStatusChartData?.TotalCustomers || 0;

    const labels = location.pathname === '/licenceDashboard'
        ? ['Active', 'Inactive']
        : ['Active', 'Inactive'];

    const data = location.pathname === '/licenceDashboard'
        ? [getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0, getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0]
        : [getCustomerDashboardStatusChartData?.ActiveCustomers || 0, getCustomerDashboardStatusChartData?.InActiveCustomers || 0];

    const colors = ['#3AC977', '#FF5E5E'];

    useImperativeHandle(ref, () => ({
        handleDownloadImage: () => {
            if (!chartInstance.current) return;

            const labels = location.pathname === '/licenceDashboard'
                ? ['Active', 'Inactive']
                : ['Active', 'Inactive'];

            const data = location.pathname === '/licenceDashboard'
                ? [getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0, getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0]
                : [getCustomerDashboardStatusChartData?.ActiveCustomers || 0, getCustomerDashboardStatusChartData?.InActiveCustomers || 0];

            const total = location.pathname === '/licenceDashboard'
                ? getLicenseDashboardLicenceStatusData?.TotalLicenses || 0
                : getCustomerDashboardStatusChartData?.TotalCustomers || 0;

            // Prepare table data
            const tableData = labels.map((label, index) => ({
                Label: label,
                Value: data[index],
            }));

            // Create a temporary container for the chart and table
            const printableContent = document.createElement('div');
            printableContent.style.position = 'absolute';
            printableContent.style.top = '-9999px';
            document.body.appendChild(printableContent);

            const chartImage = chartInstance.current.toBase64Image();

            // Add chart image
            const chartImg = document.createElement('img');
            chartImg.src = chartImage;
            chartImg.style.display = 'block';
            chartImg.style.margin = '20px auto';
            printableContent.appendChild(chartImg);

            // Add table
            const table = document.createElement('table');
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
            table.style.marginTop = '20px';
            table.innerHTML = `
                <tbody>
                    ${tableData
                    .map(
                        (row) =>
                            `<tr>
                                    <td style="border: 1px solid #ccc; padding: 8px; text-align: center;">${row.Label}</td>
                                    <td style="border: 1px solid #ccc; padding: 8px; text-align: center;">${row.Value}</td>
                                </tr>`
                    )
                    .join('')}
                </tbody>
                <tfoot>
                    <tr>
                        <th style="border: 1px solid #ccc; padding: 8px; text-align: center;">Total</th>
                        <th style="border: 1px solid #ccc; padding: 8px; text-align: center;">${total}</th>
                    </tr>
                </tfoot>
            `;
            printableContent.appendChild(table);

            // Capture the combined content using html2canvas
            html2canvas(printableContent).then((canvas) => {
                const imageData = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = imageData;
                link.download = `${location.pathname === '/licenceDashboard' ? 'Licence_Status' : 'Customer_Status'}_Chart_With_Data.png`;
                link.click();

                // Clean up temporary content
                document.body.removeChild(printableContent);
            }).catch((error) => {
                console.error("Error capturing the chart and table:", error);
            });
        },
        handleDownloadExcel: async () => {
            const labels = location.pathname === '/licenceDashboard'
                ? ['Active', 'Inactive']
                : ['Active', 'Inactive'];

            const data = location.pathname === '/licenceDashboard'
                ? [getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0, getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0]
                : [getCustomerDashboardStatusChartData?.ActiveCustomers || 0, getCustomerDashboardStatusChartData?.InActiveCustomers || 0];

            const total = location.pathname === '/licenceDashboard'
                ? getLicenseDashboardLicenceStatusData?.TotalLicenses || 0
                : getCustomerDashboardStatusChartData?.TotalCustomers || 0;

            // Create a new workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Chart Data');

            // Add data to the worksheet
            worksheet.columns = [
                { header: 'Label', key: 'Label', width: 20 },
                { header: 'Value', key: 'Value', width: 15 },
            ];

            labels.forEach((label, index) => {
                worksheet.addRow({ Label: label, Value: data[index] });
            });

            worksheet.addRow({ Label: 'Total', Value: total });

            // Add the chart image to the worksheet
            if (chartInstance.current) {
                const chartImage = chartInstance.current.toBase64Image(); // Get chart as base64 image

                try {
                    const imageId = workbook.addImage({
                        base64: chartImage,
                        extension: 'png',
                    });

                    // Position the image in the worksheet
                    worksheet.addImage(imageId, {
                        tl: { col: 3, row: 1 }, // Top-left corner
                        ext: { width: 500, height: 300 }, // Image size
                    });
                } catch (error) {
                    console.error('Error adding chart image:', error);
                }
            } else {
                console.warn('Chart instance not available. Image will not be included.');
            }

            // Download the workbook
            try {
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                saveAs(
                    blob,
                    `${location.pathname === '/licenceDashboard' ? 'Licence_Status' : 'Customer_Status'}_Chart_Data_with_Image.xlsx`
                );
            } catch (error) {
                console.error('Error downloading Excel file:', error);
            }
        },
        handleDownloadPDF: () => {
            if (!chartInstance.current) return;

            const chartImage = chartInstance.current.toBase64Image();

            // Create a canvas to crop the image into a circle
            const img = new Image();
            img.src = chartImage;

            img.onload = () => {
                // Create a circular canvas
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const size = Math.min(img.width, img.height);  // Make sure it’s a square

                // Set canvas size to the desired circle size
                canvas.width = size;
                canvas.height = size;

                // Draw the image in a circle
                ctx.beginPath();
                ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, false);
                ctx.clip();

                // Draw the image inside the circular clipping path
                ctx.drawImage(img, (size - img.width) / 2, (size - img.height) / 2);

                // Convert the canvas to a data URL (PNG)
                const circularImage = canvas.toDataURL('image/png');

                // Now generate the PDF with jsPDF
                const doc = new jsPDF();

                // Add the chart image in circular form
                doc.addImage(circularImage, 'PNG', 15, 30, 180, 180);

                // Add table below the image
                const labels = location.pathname === '/licenceDashboard' ? ['Active', 'Inactive'] : ['Active', 'Inactive'];
                const data = location.pathname === '/licenceDashboard'
                    ? [getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0, getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0]
                    : [getCustomerDashboardStatusChartData?.ActiveCustomers || 0, getCustomerDashboardStatusChartData?.InActiveCustomers || 0];

                const total = location.pathname === '/licenceDashboard'
                    ? getLicenseDashboardLicenceStatusData?.TotalLicenses || 0
                    : getCustomerDashboardStatusChartData?.TotalCustomers || 0;

                const tableData = labels.map((label, index) => [label, data[index]]);
                tableData.push(['Total', total]);

                // Add the table below the chart
                doc.autoTable({
                    head: [['Label', 'Value']],
                    body: tableData,
                    startY: 220,  // Adjust position to place the table below the chart
                    theme: 'grid',
                });

                // Save the PDF
                doc.save(`${location.pathname === '/licenceDashboard' ? 'Licence_Status' : 'Customer_Status'}_Chart.pdf`);
            };
        },

        handleDownloadWord: () => {
            const labels = location.pathname === '/licenceDashboard'
                ? ['Active', 'Inactive']
                : ['Active', 'Inactive'];

            const data = location.pathname === '/licenceDashboard'
                ? [getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0, getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0]
                : [getCustomerDashboardStatusChartData?.ActiveCustomers || 0, getCustomerDashboardStatusChartData?.InActiveCustomers || 0];

            const total = location.pathname === '/licenceDashboard'
                ? getLicenseDashboardLicenceStatusData?.TotalLicenses || 0
                : getCustomerDashboardStatusChartData?.TotalCustomers || 0;

            const chartBase64 = chartInstance.current.toBase64Image();

            const content = `
                <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
                <head><meta charset="utf-8"><title>Chart Data</title></head>
                <body>
                    <h1>Chart Data</h1>
                    <img src="${chartBase64}" alt="Chart" style="max-width: 100%; height: auto;"/>
                    <table border="1" style="border-collapse: collapse; margin-top: 20px; width: 100%;">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${labels.map((label, index) => `<tr><td>${label}</td><td>${data[index]}</td></tr>`).join('')}
                            <tr><td>Total</td><td>${total}</td></tr>
                        </tbody>
                    </table>
                </body>
                </html>
            `;

            const blob = new Blob([content], { type: 'application/msword' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${location.pathname === '/licenceDashboard' ? 'Licence_Status' : 'Customer_Status'}_Chart_Data.doc`;
            link.click();
        },

        handlePrint: () => {
            const labels = location.pathname === '/licenceDashboard'
                ? ['Active', 'Inactive']
                : ['Active', 'Inactive'];

            const data = location.pathname === '/licenceDashboard'
                ? [getLicenseDashboardLicenceStatusData?.ActiveLicenses || 0, getLicenseDashboardLicenceStatusData?.InActiveLicenses || 0]
                : [getCustomerDashboardStatusChartData?.ActiveCustomers || 0, getCustomerDashboardStatusChartData?.InActiveCustomers || 0];

            const total = location.pathname === '/licenceDashboard'
                ? getLicenseDashboardLicenceStatusData?.TotalLicenses || 0
                : getCustomerDashboardStatusChartData?.TotalCustomers || 0;

            const printableContent = `
                <div>
                    <h1>Chart Data</h1>
                    <img src="${chartInstance.current.toBase64Image()}" alt="Chart" style="display:block; margin: 20px auto;" />
                    <table border="1" style="border-collapse: collapse; margin-top: 20px; width: 100%; text-align: center;">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${labels.map((label, index) => `<tr><td>${label}</td><td>${data[index]}</td></tr>`).join('')}
                            <tr><td>Total</td><td>${total}</td></tr>
                        </tbody>
                    </table>
                </div>
            `;

            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(printableContent);
                newWindow.document.close();
                newWindow.print();
            } else {
                alert('Popup is blocked. Please allow popups for this site.');
            }
        },
    }));


    return (
        <div className='barchart-container relation-type-chart-container'>
            <div>
                <h6>{moduleName}</h6>
                <div className='relation-type-chart-btns'>
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-company">
                            {selectedCompany?.label ? selectedCompany?.label : 'Select Company'}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {getCompanyDropdown.map(option => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleCompanySelect(option)}
                                    active={selectedCompany.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-year">
                            {selectedYear?.label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {generateYearRange(2022).map(option => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleYearSelect(option)}
                                    active={selectedYear.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className='customer-status-chart'>
                <div style={{ width: '70%', height: '225px' }} className='customer-status-canvas-div'>
                    <canvas ref={chartRef} />
                </div>
                {/* <div style={{ fontSize: '14px', textAlign: 'right' }}>
                    <p>Total: <strong>{total}</strong></p>
                    {labels.map((label, index) => (
                        <p key={label} style={{ color: colors[index] }}>
                            {label}: <strong>{data[index]}</strong>
                        </p>
                    ))}
                </div> */}

                <div className="carousel-container">
                    <Carousel>
                        {/* Slide showing the total */}
                        <Carousel.Item>
                            <div className="customer-status-indicator-names">
                                <p>Total: <strong>{total}</strong></p>
                            </div>
                        </Carousel.Item>

                        {/* Slide for each label */}
                        {labels.map((label, index) => (
                            <Carousel.Item key={label}>
                                <div className="d-flex flex-column align-items-end p-3">
                                    <p style={{ color: colors[index] }}>
                                        {label}: <strong>{data[index]}</strong>
                                    </p>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
                <div style={{ fontSize: '14px', textAlign: 'right' }} className='carousel-none-div'>
                    <p>Total: <strong>{total}</strong></p>
                    {labels.map((label, index) => (
                        <p key={label} style={{ color: colors[index] }}>
                            {label}: <strong>{data[index]}</strong>
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
});

export default CustomerStatusChart;
